module.exports = __webpack_public_path__ + "media/images/icon__calendar@3x-87f1c2a454007657d83c762a203b9e20.png";